const codeKey = (value) => String(value ?? "").trim().toUpperCase();

export function suggestNumericCode(records = []) {
  const used = new Set(records.map(({ code }) => codeKey(code))
    .filter((code) => /^\d+$/.test(code)).map(Number).filter(Number.isSafeInteger));
  let candidate = 1;
  while (used.has(candidate)) candidate += 1;
  return String(candidate).padStart(4, "0");
}

// Enumerate distinct six-letter subsequences in name order, starting with its first six letters.
function* combinations(letters, start = 0, prefix = "") {
  if (prefix.length === 6) { yield prefix; return; }
  const seen = new Set();
  for (let index = start; index <= letters.length - (6 - prefix.length); index += 1) {
    const letter = letters[index];
    if (seen.has(letter)) continue;
    seen.add(letter);
    yield* combinations(letters, index + 1, prefix + letter);
  }
}

export function suggestAlphabeticCode(name, records = []) {
  let letters = String(name ?? "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toUpperCase().replace(/[^A-Z]/g, "");
  if (!letters) return null;
  if (letters.length < 6) letters = letters.repeat(Math.ceil(6 / letters.length));
  const used = new Set(records.map(({ code }) => codeKey(code)));
  for (const candidate of combinations(letters)) {
    if (!used.has(candidate)) return candidate;
  }
  return null;
}
